import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef, Fragment } from "react";
import { css } from "emotion";
import { useNewOffer } from "../../../../../../js/context/new-offer";
import R from "ramda";
import Input from "../../../../../../../offers/shared/AtomicInput";
import { offerMilesStyle, averageMilesStyle } from "./style";
import { currencyMask, milesMask } from "../../../../../../shared/create-offer/utils/masks";
import {
	intFormat,
	formatOnlyNumbers,
	formatCurrency,
	floatFormat
} from "../../../../../../shared/create-offer/utils/formats";
import Loading from "../../../../../../shared/create-offer/Loading/Loading";
import InputForm from "../../../../../../shared/atoms/InputForm";
import {
	MANAGER_LIMIT_AVERAGE_MILES,
	MINIMAL_MILES_ADVANCED_AVERAGE,
	MINIMAL_MILES_SMILES_REDUCTIONS,
	AIRLINE_PROGRAMS
} from "../../../../../../js/shared/enums";
import SelectForm from "../../../../../../shared/atoms/SelectForm";
import SwitchForm from "../../../../../../shared/atoms/SwitchForm";
import { Heading } from "@maxmilhas/hangar-components-atomic/public";
import MessageBar from "../../../../../../shared/create-offer/MessageBar/MessageBar";
import ArrowRight from "../../../../../../shared/Arrows/ArrowRight";
import { AverageMessage } from "../../../../shared/miles-average/AverageMessage";
import RankingOffers from "../../../../../../shared/create-offer/RankingOffers/RankingOffers";
import AcceptanceTerms from "../../../../../../shared/create-offer/AcceptanceTerms/AcceptanceTerms";
import StepEditFidelityAndBank from "../StepEditFidelityAndBank";
import mask from "../../../../../shared/moneyMask";
import { bonusStyle } from "../../style";
import {
	MULTIPLE_MILES_OFFER as multipleMilesOffer
} from "../../../../../../../js/shared/constants";
import { Tooltip } from "react-tippy";
import theme from "../../../../../../../js/shared/new-theme";
import { Icon } from "@maxmilhas/hangar-components-atomic/public";
import { formatPaymentDeadline } from "../../../../../../shared/create-offer/utils/formats";
import Callout from "../../../../../../shared/create-offer/Callout/Callout";
import EditFidelityProgramDetails from "../StepEditFidelityAndBank/EditFidelityProgramDetails";
import { LatamFacialAuthRequiredModal } from "../../../../../services/modals";
import { isLatam, redirectToMilesSale } from "../../../../../shared/utils";

// Debounce function
let timerId;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	timerId = setTimeout(fn, delay);
};

const StepEditOfferMiles = forwardRef(
	(
		{
			setOpenBankFidedity,
			checkData,
			passData,
			setModalDynamicRange,
			openModalDynamicBonus,
			bonusValid
		},
		ref
	) => {
		const {
			currentProgram,
			fetchRankingData,
			participantData,
			offerData,
			rankingData,
			pricesData,
			setSmilesRange,
			setOfferData,
			setRankingData,
			fetchPricesData,
			smilesDiamond,
			setSmilesDiamond,
			statisticSales,
			fetchStatisticSales,
			newOfferTempData,
			acceptanceTerms,
			setAcceptanceTerms,
			bonusData: { data: bonusData },
			editOffer,
			airlineProgramsSettings,
			loyaltyData,
			setLoyaltyData,
			request2FACodeLatam,
			email2FAStatusValidation,
			status2FAEnabledFeature,
			phoneMultiplus,
			hasClickedRequest2FACode,
			setHasClickedRequest2FACode,
			twoFactorData,
			hasTriedToProceedWithout2FA
		} = useNewOffer();
		const {
			minMiles,
			maxMiles,
			minPrice,
			maxPrice,
			valSuggestMin,
			valSuggestMax
		} = pricesData.data;

		const typePhoneLatam = loyaltyData.data.phoneRequiredMode;

		const [valid, setValid] = useState(false);
		const [priceOfferMiles, setPriceOfferMiles] = useState(
			!!offerData.data.price && offerData.data.price !== "undefined" ? `R$ ${formatCurrency(offerData.data.price)}` : ""
		);
		const [quantOfferMiles, setQuantOfferMiles] = useState(
			offerData.data.quant || editOffer.quant || ""
		);
		const [paymentDeadline, setPaymentDeadline] = useState(
			offerData.data.paymentDeadline || editOffer.paymentDeadline || ""
		);
		const [paymentScheduleType, setPaymentScheduleType] = useState(
			offerData.data.paymentScheduleType || editOffer.paymentScheduleType || ""
		);
		const quantRef = useRef(quantOfferMiles);
		const [maxAverage, setMaxAverage] = useState(
			participantData.hasManagementActive ? MANAGER_LIMIT_AVERAGE_MILES : offerData.data.averageMilesMax || 0
		);

		const [errors, setErrors] = useState({
			priceOfferMiles:
				priceOfferMiles &&
				(floatFormat(priceOfferMiles) < minPrice || floatFormat(priceOfferMiles) > maxPrice),
			quantOfferMiles: quantOfferMiles && ((quantOfferMiles < minMiles || quantOfferMiles > maxMiles) || quantOfferMiles % multipleMilesOffer !== 0)
		});
		const [averageOfferMiles, setAverageOfferMiles] = useState(offerData.data.averageMiles || "");
		const [averageMilesPerTicket, setAverageMilesPerTicket] = useState(
			offerData.data.averageMiles || ""
		);
		const [advancedSettings, setAdvancedSettings] = useState(false);
		const [reductions, setReductions] = useState(offerData.data.reductions || 0);
		const [optionsMilesReductionTickets, setOptionsMilesReductionTickets] = useState([]);
		const [optionsAverageMilesPerTicket, setOptionsAverageMilesPerTicket] = useState([]);
		const [state, setState] = useState({
			inputInFocus: ""
		});

		const [showModalLatamFacialAuthRequired, setShowModalLatamFacialAuthRequired] = useState(isLatam(currentProgram.id));

		const setInputInFocus = component => {
			let temp = {
				...state,
				inputInFocus: component
			};

			setState(temp);
		};

		const showReductions =
			currentProgram.id === AIRLINE_PROGRAMS.SMILES.id &&
			!participantData.hasManagementActive &&
			smilesDiamond === true &&
			!!optionsMilesReductionTickets.length;

		const [modals, setModals] = useState({
			mediaVendas: false,
			firstOpen: false,
			numberAverageTicket: 0,
			value: 0,
			sale: {}
		});

		// Pass ref to modals
		useImperativeHandle(ref, () => ({
			async confirmVendasModal() {
				setAverageMilesPerTicket(modals.value.length ? modals.numberAverageTicket : "");
				await setOfferData({
					data: { ...offerData.data, averageMiles: modals.numberAverageTicket }
				});
				await fetchPricesData(quantOfferMiles, currentProgram, modals.numberAverageTicket);
			}
		}));

		useEffect(() => {
			handleReductions(
				pricesData.data.reductionRanges,
				quantOfferMiles,
				reductions,
				averageMilesPerTicket,
				offerData.data.averageMilesMax
			);
		}, []);

		useEffect(() => {
			setSmilesRange(reductions && optionsAverageMilesPerTicket);
		}, [reductions, optionsAverageMilesPerTicket]);

		useEffect(() => {
			let average = offerData.data.averageMiles || "";
			if (average && average !== averageOfferMiles) {
				if (reductions) {
					onChange("averageMilesPerTicket", String(average));
				} else {
					onChange("averageOfferMiles", average);
				}
			}
		}, [offerData.data.averageMiles]);

		useEffect(() => {
			setAverageOfferMiles(averageMilesPerTicket);
		}, [averageMilesPerTicket]);

		useEffect(() => {
			const averageMilesMax = parseInt(offerData.data.averageMilesMax);
			if (averageMilesMax > 0)
				setMaxAverage(averageMilesMax);
		}, [offerData.data.averageMilesMax]);

		useEffect(() => {
			if (
				newOfferTempData.form.completedBoxDataBankDetails !== undefined &&
				newOfferTempData.form.completedBoxDataFidelityProgramDetails !== undefined &&
				((!newOfferTempData.form.completedBoxDataBankDetails &&
					!participantData.hasManagementActive) ||
					!newOfferTempData.form.completedBoxDataFidelityProgramDetails)
			) {
				localStorage.setItem("openBankFidelity", "1");
				setOpenBankFidedity();
			}
		}, [
			newOfferTempData.form.completedBoxDataBankDetails,
			newOfferTempData.form.completedBoxDataFidelityProgramDetails
		]);

		const getReductions = async (isSmilesDiamond) => {
			await fetchRankingData(quantOfferMiles, currentProgram, undefined, false, async data => {
				await handleReductions(data.reductionRanges, quantOfferMiles, undefined, undefined, isSmilesDiamond, maxAverage);
			});
		};

		const toggleCheckSmiles = async value => {
			setSmilesDiamond(value);

			if (value) {
				if (optionsMilesReductionTickets.length > 0) {
					changeReduction(
						optionsMilesReductionTickets[optionsMilesReductionTickets.length - 1].quantReduction
					);
				} else {
					await getReductions(value);
				}
			} else {
				changeReduction(0);
			}
		};

		const handleReductions = async (
			reductionRanges = [],
			quantMiles,
			defaultReduction,
			averageMilesPerTicket,
			isSmilesDiamond = false,
			averageMax
		) => {
			if (reductionRanges.length) {
				let newReductions = [
					{
						label: "0 passageiro",
						value: 0
					}
				];

				let reductionsSorted = R.sortBy(R.prop("quantReduction"), reductionRanges);
				reductionsSorted.forEach(r => {
					newReductions.push({
						...r,
						label: `${r.quantReduction} passageiro${r.quantReduction > 1 ? "s" : ""}`,
						value: r.quantReduction
					});
				});
				setOptionsMilesReductionTickets(newReductions);
				// Checkbox marcado OU usuario salvo com categoria diamante
				if (
					(isSmilesDiamond || smilesDiamond) &&
					quantMiles >= MINIMAL_MILES_SMILES_REDUCTIONS &&
					(defaultReduction === undefined || defaultReduction > 0) // Caso for redução 0 não precisa setar
				) {
					return await changeReduction(
						defaultReduction || reductionsSorted[reductionsSorted.length - 1].quantReduction,
						newReductions,
						quantMiles,
						averageMilesPerTicket,
						averageMax
					);
				}
			} else {
				setOptionsMilesReductionTickets([]);
				setOptionsAverageMilesPerTicket([]);
			}

			return {};
		};

		const changeReduction = async (
			value,
			reductionRanges = optionsMilesReductionTickets,
			quant = quantOfferMiles,
			averageMilesPerTicket,
			averageMax
		) => {
			setReductions(value);
			let newReduction = reductionRanges.find(r => r.quantReduction === value);
			let newOfferData = {
				...offerData.data,
				quant
			};
			if (newReduction) {
				let newAverages = [];
				newReduction.averageRanges.forEach(a => {
					if (averageMax && averageMax > 0 && a > averageMax) return;
					
					newAverages.push({
						label: intFormat(a),
						value: a
					});
				});
				setOptionsAverageMilesPerTicket(newAverages);

				let newAverageMiles = averageMilesPerTicket
					? newReduction.averageRanges.find(av => av === averageMilesPerTicket)
					: undefined;
				newAverageMiles = newAverageMiles || newReduction.averageRanges[0];
				setAverageMilesPerTicket(newAverageMiles);

				newOfferData = {
					...newOfferData,
					reductions: value,
					averageMiles: newReduction.averageRanges[0]
				};
				await setOfferData({
					data: newOfferData
				});
				await fetchPricesData(quant, currentProgram, newReduction.averageRanges[0]);
			} else {
				let newAverageMiles = rankingData.data.averageMilesSuggestion || averageOfferMiles;
				setAverageOfferMiles(newAverageMiles);
				newOfferData = {
					...newOfferData,
					reductions: value,
					averageMiles: newAverageMiles
				};
				await setOfferData({
					data: newOfferData
				});
				await fetchPricesData(quant, currentProgram, newAverageMiles);
			}

			return newOfferData;
		};

		const onChange = async (name, value) => {
			switch (name) {
				case "milesReductionTickets":
					value = parseInt(value);
					changeReduction(value, optionsMilesReductionTickets, quantOfferMiles, undefined, maxAverage);
					break;
				case "priceOfferMiles":
					let price = value.length ? floatFormat(value) : undefined;

					let priceOfferMilesIsValid = price >= minPrice && price <= maxPrice;

					setPriceOfferMiles(value);
					setErrors({
						...errors,
						priceOfferMiles: !priceOfferMilesIsValid
					});

					await setOfferData({
						data: {
							...offerData.data,
							price: formatCurrency(price),
							invalid: !priceOfferMilesIsValid
						}
					});
					break;
				case "quantOfferMiles":
					let numberQuant = value.length ? parseInt(formatOnlyNumbers(value)) : undefined;

					let quantOfferMilesIsValid = numberQuant >= minMiles && numberQuant <= maxMiles && numberQuant % multipleMilesOffer === 0;

					quantRef.current = numberQuant;

					setQuantOfferMiles(value.length ? numberQuant : "");
					setMaxAverage(
						participantData.hasManagementActive
							? MANAGER_LIMIT_AVERAGE_MILES
							: value.length
								? numberQuant
								: 0
					);
					setAverageOfferMiles("");
					let newErrors = {
						...errors,
						quantOfferMiles: !quantOfferMilesIsValid
					};
					setErrors(newErrors);

					if (quantOfferMilesIsValid) {
						let newOfferData = { ...offerData.data, quant: numberQuant };
						if (numberQuant < 60000) {
							newOfferData.averageMiles = 3500;
							if (smilesDiamond) {
								// Caso usuário for diamante e esta ofertando menos que 60k
								newOfferData.reductions = numberQuant >= 35000 ? 1 : 0;
							}
						}
						await setOfferData({
							data: newOfferData
						});
						await fetchRankingData(numberQuant, currentProgram, undefined, false, async data => {
							if (quantRef.current != numberQuant) {
								return;
							}

							const averageMilesMax = parseInt(data.averageMilesMax) || numberQuant;
							if (!participantData.hasManagementActive && averageMilesMax)
								setMaxAverage(numberQuant < averageMilesMax ? numberQuant : averageMilesMax);

							newOfferData = {
								...newOfferData,
								...(await handleReductions(data.reductionRanges, numberQuant, undefined, undefined, undefined, averageMilesMax))
							};

							let averageMiles = data.averageMilesSuggestion;
							if (!averageMiles || !data.countAllowedSales) {
								setAdvancedSettings(true);
							}

							if (!smilesDiamond) {
								setAverageOfferMiles(averageMiles);
								await setOfferData({
									data: { ...newOfferData, averageMiles }
								});
								if (averageMiles >= minMiles) {
									setErrors({
										...newErrors,
										averageOfferMiles:
											averageMiles < minMiles ||
											averageMiles > numberQuant ||
											(participantData.hasManagementActive &&
												averageMiles > MANAGER_LIMIT_AVERAGE_MILES)
									});
								}
							} else if (numberQuant < 60000 && !!data.countAllowedSales) {
								// Caso usuário for diamante e esta ofertando menos que 60k
								newOfferData.reductions = numberQuant >= 35000 ? 1 : 0;
								setAverageOfferMiles(3500);
								await setOfferData({
									data: { ...newOfferData }
								});
							}
						}, paymentDeadline, paymentScheduleType);
					} else {
						setRankingData({ ...rankingData, data: {} });
						setPriceOfferMiles("");
						await setOfferData({
							data: { ...offerData.data, price: "" }
						});
					}
					break;
				case "averageMilesPerTicket":
					let numberAverageTicket = value.length ? parseInt(formatOnlyNumbers(value)) : undefined;
					if (
						!showReductions &&
						numberAverageTicket > 25000 &&
						!modals.firstOpen &&
						offerData.data.quant >= MINIMAL_MILES_ADVANCED_AVERAGE
					) {
						let sale = statisticSales.data.find(
							val =>
								val.initialMiles <= numberAverageTicket && val.finalMiles >= numberAverageTicket
						);

						setModals({
							mediaVendas: true,
							firstOpen: true,
							numberAverageTicket,
							value,
							sale
						});

						passData({
							mediaVendas: true,
							firstOpen: true,
							numberAverageTicket,
							averageMilesSuggestion: rankingData.data.averageMilesSuggestion,
							value,
							sale
						});

						return;
					}
					setAverageMilesPerTicket(value.length ? numberAverageTicket : "");
					await setOfferData({
						data: { ...offerData.data, averageMiles: numberAverageTicket }
					});
					await fetchRankingData(quantOfferMiles, currentProgram, numberAverageTicket, false, null, paymentDeadline, paymentScheduleType);
					break;
				case "averageOfferMiles":
					let numberAverage = value.length ? parseInt(formatOnlyNumbers(value)) : undefined;

					let averageOfferMilesIsValid = numberAverage >= minMiles && numberAverage <= maxAverage;

					setAverageOfferMiles(value.length ? numberAverage : "");
					setErrors({
						...errors,
						averageOfferMiles: !averageOfferMilesIsValid
					});

					if (averageOfferMilesIsValid) {
						// await fetch new prices
						await setOfferData({
							data: { ...offerData.data, averageMiles: numberAverage }
						});
						await fetchRankingData(quantOfferMiles, currentProgram, numberAverage, false, null, paymentDeadline, paymentScheduleType);
						if (numberAverage > 25000) {
							await fetchStatisticSales();
						}
					}
					break;
				case "showAdvancedSettings":
					setAdvancedSettings(!advancedSettings);
					break;
			}
		};

		const getAdvancedConfigMinMiles = () =>
			bonusData && bonusData.enabled ? bonusData.minMiles : MINIMAL_MILES_ADVANCED_AVERAGE;

		const ruleOver60 =
			quantOfferMiles >= getAdvancedConfigMinMiles(currentProgram) &&
			(currentProgram.international === "0" || !currentProgram.international || currentProgram.id === AIRLINE_PROGRAMS.TAP.id);

		let newValid =
			quantOfferMiles && priceOfferMiles && !errors.quantOfferMiles && !errors.priceOfferMiles;
		let average = reductions > 0 ? averageMilesPerTicket : averageOfferMiles;
		if (ruleOver60) {
			newValid =
				newValid &&
				average &&
				average >= minMiles &&
				average <= maxAverage &&
				!errors.averageOfferMiles;
		}

		if (valid !== newValid) {
			setValid(newValid);
			checkData("completedBoxOfferMiles", newValid);
		}

		const selectPassengers = showReductions ? (
			<div className="miles-reduction-tickets">
				<SelectForm
					value={reductions}
					name="milesReductionTickets"
					options={optionsMilesReductionTickets.map(r => {
						return { label: r.label, value: r.value };
					})}
					onChange={ev => {
						let val = ev.target.value;
						debounced(() => onChange("milesReductionTickets", val), 300);
					}}
					defaultOption=""
					label="Passagens com redução de milhas"
					data-action="simulator-miles-reducao-select"
				/>
			</div>
		) : null;

		const inputCheckDiamond = currentProgram.id === AIRLINE_PROGRAMS.SMILES.id && !participantData.hasManagementActive && (
			<>
				<hr className="check-smiles-diamond--separator" />
				<div className="check-smiles-diamond--wrapper">
					<Input
						name="checkSmilesDiamond"
						id="checkSmilesDiamond"
						type="checkbox"
						label={
							<span className="check-smiles-diamond--label">
								Eu sou cliente da <strong>Categoria Diamante</strong>
							</span>
						}
						value={!!smilesDiamond}
						checked={!!smilesDiamond}
						onChange={() => toggleCheckSmiles(!smilesDiamond)}
					/>
				</div>
			</>
			);

		const blockAlertLatam = twoFactorData.is2FAEnabled && !twoFactorData.code && (
			<div className="form-group">
				<Callout show warn text={<span>{twoFactorData.alert}</span>} />
			</div>
		);

		const setLoyaltyDataFn = data => {
			setLoyaltyData({
				...loyaltyData,
				data: { ...loyaltyData.data, ...data }
			});
		};

		const blockEditFidelityProgramDetails = twoFactorData.is2FAEnabled && (
			<EditFidelityProgramDetails
				checkData={checkData}
				inputInFocus={state.inputInFocus}
				setData={setLoyaltyDataFn}
				setInputInFocus={setInputInFocus}
				fidelityProgram={currentProgram}
				userData={loyaltyData.data}
				phoneMMSuggestion={phoneMultiplus}
				typePhoneLatam={typePhoneLatam}
				airlineProgramsSettings={airlineProgramsSettings}
				status2FAEnabledFeature={status2FAEnabledFeature}
				email2FAStatusValidation={email2FAStatusValidation}
				offerData={offerData}
				request2FACodeLatam={request2FACodeLatam}
				hasClickedRequest2FACode={hasClickedRequest2FACode}
				setHasClickedRequest2FACode={setHasClickedRequest2FACode}
				twoFactorData={twoFactorData}
				hasTriedToProceedWithout2FA={hasTriedToProceedWithout2FA}
			/>
		);

		const blockQuantMiles = (
			<div className="quant-offer-miles">
				<div className="payment-deadline--wrapper">
					<InputForm
						className="payment-deadline--component"
						name="paymentDeadline"
						id="paymentDeadline"
						value={formatPaymentDeadline(paymentDeadline, paymentScheduleType)}
						disabled
						placeholder=""
						label={
							<Fragment>Prazo de pagamento 
								<Tooltip
									tabIndex={0}
									arrow={true}
									position="top"
									theme="light"
									html={
										<p
											style={{
												color: theme.palette.gray[500].value
											}}
										>
											O prazo para o pagamento começa a contar a partir das emissões das passagens.
										</p>
									}
								>
									<Icon
										name="icon-max-communication-doubt"
										size="small"
										color={theme.palette.secondary[500].value}
									/>
								</Tooltip>
							</Fragment>}
					/>
				</div>
				<div className="quant-offer-miles--wrapper">
					<InputForm
						className="quant-offer-miles--component"
						name="quantOfferMiles"
						id="quantOfferMiles"
						type="tel"
						value={intFormat(quantOfferMiles)}
						onChange={ev => onChange("quantOfferMiles", ev.target.value)}
						placeholder=""
						label="Milhas ofertadas"
						mask={milesMask}
						hasError={errors.quantOfferMiles}
						errorMessage={
							quantOfferMiles < minMiles
								? `A oferta precisa ter no mínimo ${intFormat(minMiles)} milhas`
								: quantOfferMiles > maxMiles
									? `A oferta precisa ter no máximo ${intFormat(maxMiles)} milhas`
									: `Vendas só de ${multipleMilesOffer} em ${multipleMilesOffer} milhas`
						}
						data-action="simulator-miles-quant-miles"
					/>
				</div>
				{ruleOver60 && (
					<SwitchForm
						name="showAdvancedSettings"
						id="showAdvancedSettings"
						label="Exibir configurações avançadas"
						onChange={checked => onChange("showAdvancedSettings", checked)}
						checked={advancedSettings}
						dataAction="simulator-miles-advanced-settings"
					/>
				)}
			</div>
		);

		const inputOrSelectAverageMiles =
			!showReductions || !reductions ? (
				<div className="average-offer-miles--wrapper">
					<InputForm
						className="average-offer-miles--component"
						name="averageOfferMiles"
						id="averageOfferMiles"
						type="tel"
						value={intFormat(averageOfferMiles)}
						onChange={ev => {
							let val = ev.target.value;
							debounced(() => onChange("averageOfferMiles", val), 300);
						}}
						placeholder=""
						label="Média de milhas por passageiro"
						mask={milesMask}
						disabled={rankingData.isFetching}
						hasError={errors.averageOfferMiles}
						errorMessage={
							!averageOfferMiles || averageOfferMiles < 3500
								? `A média precisa ter no mínimo ${intFormat(minMiles)} milhas`
								: `A média precisa ter no máximo ${intFormat(maxAverage)} milhas`
						}
						data-action="simulator-miles-average-miles"
					/>
				</div>
			) : (
				<div className="average-miles-per-ticket">
					<SelectForm
						name="averageMilesPerTicket"
						value={averageMilesPerTicket}
						options={optionsAverageMilesPerTicket}
						onChange={ev => {
							let val = ev.target.value;
							debounced(() => onChange("averageMilesPerTicket", val), 300);
						}}
						defaultOption="A partir de:"
						label="Média de milhas por passageiro"
						data-action="simulator-miles-average-miles"
					/>
				</div>
			);

		const blockAverageMiles = advancedSettings && ruleOver60 && (
			<>
				{inputCheckDiamond}
				{selectPassengers}
				{inputOrSelectAverageMiles}
				<div
					className={css`
						${averageMilesStyle}
					`}
				>
					<div className="info">
						{rankingData.isFetching ? (
							<div className="info-loading">
								<Loading width={36} height={36} />
							</div>
						) : (
							!!rankingData.data.averageMilesSuggestion &&
							(!showReductions || !reductions) && (
								<AverageMessage
									averageMilesSuggestion={rankingData.data.averageMilesSuggestion}
									averageMiles={averageOfferMiles}
									data={statisticSales.data}
									minMiles={minMiles}
									maxAverage={maxAverage}
								/>
							)
						)}
					</div>
					<hr className="average-separator" />
				</div>
			</>
		);

		const blockPrice = (
			<div className="price-offer-miles">
				<div className="price-offer-miles--wrapper">
					<InputForm
						className="price-offer-miles--component"
						name="priceOfferMiles"
						id="priceOfferMiles"
						type="tel"
						disabled={!quantOfferMiles || errors.quantOfferMiles}
						value={priceOfferMiles}
						maxlength="8"
						onKeyUp={ev => {
							![8, 46, 37, 39].includes(ev.keyCode) &&
								ev.target.setSelectionRange(ev.target.value.length, ev.target.value.length);
						}}
						onChange={ev => {
							let val = ev.target.value;
							const { maskedValue } = mask(val, 2, ",", ".", false, "R$ ");
							setPriceOfferMiles(maskedValue);
							debounced(() => onChange("priceOfferMiles", maskedValue), 300);
						}}
						placeholder=""
						label="Valor a cada 1.000 milhas"
						guide={false}
						hasError={errors.priceOfferMiles && !errors.quantOfferMiles}
						errorMessage={`O valor precisa estar entre ${formatCurrency(
							minPrice
						)} e ${formatCurrency(maxPrice)}`}
						data-action="simulator-miles-price"
					/>
				</div>
				{rankingData.isFetching || pricesData.isFetching ? (
					<div className="price-offer-miles--loading">
						<Loading width={36} height={36} />
					</div>
				) : !!quantOfferMiles && !errors.quantOfferMiles ? (
					<>
						<p className="price-offer-miles--text">
							Sugerido entre&nbsp;
							<span>R$ {formatCurrency(valSuggestMin)}</span> e&nbsp;
							<span>R$ {formatCurrency(valSuggestMax)}</span>
						</p>
						<RankingOffers editMobile={true} />
					</>
				) : (
					<></>
				)}
			</div>
		);

		const blockOpenFidelityAndBank = (
			<div
				className="fidelity-and-bank"
				onClick={() => setOpenBankFidedity()}
				dataAction="fidelity-and-bank-open"
			>
				<span className="fidelity-and-bank--text">
					<strong>
						{twoFactorData.is2FAEnabled
							? "Dados bancários"
							: participantData.hasManagementActive
							? "Dados do programa de fidelidade"
							: "Dados bancários e do programa"}
					</strong>
				</span>
				<ArrowRight />
			</div>
		);

		const blockOpenDynamicRange = false && (
			<div
				className="dynamic-range"
				onClick={() => setModalDynamicRange()}
				dataAction="dynamic-range-open"
			>
				<span className="dynamic-range--text">
					<strong>Quer cadastrar um valor maior?</strong>
				</span>
				<ArrowRight />
			</div>
		);

		const blockOpenDynamicBonus = bonusValid && (
			<div
				className={css`
					${bonusStyle};
				`}
				onClick={openModalDynamicBonus}
				dataAction="dynamic-bonus-open"
			>
				<div className="dynamic-bonus--text">
					<p>
						Bônus <span>Aproveite</span>
					</p>
				</div>
				<ArrowRight onClick={openModalDynamicBonus} />
			</div>
		);

		return (
			<div
				className={css`
					${offerMilesStyle}
				`}
			>
				<Heading tag="h6">Oferta de milhas</Heading>

				{blockAlertLatam}

				<div className="row">
					<div className="col-xs-16">{blockQuantMiles}</div>
					<div className="col-xs-16">{blockAverageMiles}</div>
					<div className="col-xs-16">{blockPrice}</div>
					{blockOpenDynamicRange && <div className="col-xs-16">{blockOpenDynamicRange}</div>}
					{blockOpenDynamicBonus && <div className="col-xs-16">{blockOpenDynamicBonus}</div>}
					<div className="col-xs-16">{blockEditFidelityProgramDetails}</div>
					<div className="col-xs-16">{blockOpenFidelityAndBank}</div>
					<div className="col-xs-16">
						<div className="acceptance-terms-mobile">
							<AcceptanceTerms
								acceptanceTerms={acceptanceTerms}
								setAcceptanceTerms={setAcceptanceTerms}
							/>
						</div>
					</div>
					<div className="col-xs-16">
						<MessageBar bottomSize="77px" />
						{/* Trigger box validation
						<div className="hidden-component">
							<StepEditFidelityAndBank checkData={checkData} currentProgram={currentProgram} />
						</div> */}
					</div>
				</div>
				<LatamFacialAuthRequiredModal
					show={showModalLatamFacialAuthRequired}
					width={'95%'}
					onCancel={redirectToMilesSale}
					onConfirm={() => setShowModalLatamFacialAuthRequired(false)}
				/>
			</div>
		);
	}
);

export default StepEditOfferMiles;
